export const convertStringToBoolean = (value: string): boolean => {
  const trueValues = ["VERDADEIRO", "VERDADERO", "TRUE"];
  return trueValues.includes(value?.toUpperCase());
};
